export const FETCH_ACTIVE_LANGUAGES_REQUEST = "FETCH_ACTIVE_LANGUAGES_REQUEST";
export const FETCH_ACTIVE_LANGUAGES_SUCCESS = "FETCH_ACTIVE_LANGUAGES_SUCCESS";
export const FETCH_ACTIVE_LANGUAGES_FAIL = "FETCH_ACTIVE_LANGUAGES_FAIL";

export const FETCH_TRANSLATIONS_REQUEST = "FETCH_TRANSLATIONS_REQUEST";
export const FETCH_TRANSLATIONS_SUCCESS = "FETCH_TRANSLATIONS_SUCCESS";
export const FETCH_TRANSLATIONS_FAIL = "FETCH_TRANSLATIONS_FAIL";

export const SET_SELECTED_LANGUAGE = "SET_SELECTED_LANGUAGE";
